import BreadCrumb from "components/Common/BreadCrumb";
import { Table, Tag, Button, Spin } from 'antd';
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import {
  COLOR_CONTENT_AI_APPROVAL_STATUS,
  COLOR_CONTENT_COMMENT_STATUS,
  COLOR_CONTENT_TYPE,
  COLOR_LIST_COMMENT_SOURCE,
  COLOR_LIST_TYPE_COMMENT,
  LIST_COMMENT_SOURCE_OPTION,
  LIST_CONTENT_AI_APPROVAL_STATUS_OPTION,
  LIST_CONTENT_COMMENT_STATUS_OPTION,
  LIST_CONTENT_TYPE_OPTION,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_TYPE_COMMENT_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC, formatNumberWithCommas } from "helpers/format";
import CollapseFilter from "components/Common/CollapseFilter";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import ModalPreview from "components/Common/ModalPreview";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import CopyWrapper from "components/Common/CopyWrapper";
import NO_IMAGE_USER from "../../assets/images/no-user.png";
import CollapseContent from "components/Common/CollapseContent";
import DropdownAsyncPost from "components/Common/DropdownAsyncPost";
import { getCommentList } from "store/comment/thunk";
import commentApi from "api/commentApi";

import UpdateDropdownStatus from "components/Common/UpdateDropdownStatus";
import ContentForm from "pages/ContentManagement/Content/ContentForm";
import contentApi from "api/contentApi";
import { set } from "lodash";
interface CommentRecord {
  id: number;
  status: string;
  approvalStatus: string;
  comment: string;
  user: {
    type: string;
    profile?: { imageUrls?: string[]; nickname?: string; email?: string };
    store?: { thumbnailUrl?: string; managerName?: string; managerEmail?: string };
    email?: string;
    providerId?: string;
  };
  referralCode: string;
  source: string;
  type: string;
  createdAt: string;
  replies?: boolean;
  level?: number;
  hasMoreReplies?: boolean;
  currentPage?: number;
  children?: CommentRecord[];
  parentCommentId?: number;
  recordParent?: any;
  post?: any;
}
interface Option {
  label: string;
  value: string;
}

const SORT_BY_DEFAULT = 'createdAt';
const ORDER_BY_DEFAULT = 'desc';

registerLocale("en", en);
registerLocale("ko", ko);

const CommentList = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    comment: withDefault(StringParam, ""),
    type: withDefault(StringParam, ""),
    source: withDefault(StringParam, ""),
    approvalStatus: withDefault(StringParam, ""),
    postId: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    sortBy: withDefault(StringParam, SORT_BY_DEFAULT),
    orderBy: withDefault(StringParam, ORDER_BY_DEFAULT),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : null,
    query?.endDate ? moment(query?.endDate || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [postIDSearch, setPostIDSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  })

  const [commentSearch, setCommentSearch] = useState<string>(
    query?.comment || ""
  );
  const [typeCommentSearch, setTypeCommentSearch] = useState<Option | any>(
    LIST_TYPE_COMMENT_OPTION?.find((item) => item?.value === query?.type)
      ?.value || ""
  );
  const [commentSourceSearch, setCommentSourceSearch] = useState<Option | any>(
    LIST_COMMENT_SOURCE_OPTION?.find((item) => item?.value === query?.source)
      ?.value || ""
  );
  const [approvedStatusSearch, setApprovedStatusSearch] = useState<Option | any>(
    LIST_CONTENT_AI_APPROVAL_STATUS_OPTION?.find((item) => item?.value === query?.approvalStatus)
      ?.value || ""
  );

  const [statusSearch, setStatusSearch] = useState<Option | any>(
    LIST_OPTION_BAR_LIST_OPEN_STATUS?.find(
      (item) => item?.value === query?.status
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Comment;
  const CommentProperties = createSelector(selectLayoutState, (state) => ({
    lstComment: state.lstComment,
    isCommentLoading: state.isCommentLoading,
    isCommentSuccess: state.isCommentSuccess,
    error: state.error,
  }));

  // Inside your component
  const { lstComment, isCommentLoading } = useSelector(CommentProperties);
  const [summaryData, setSummaryData] = useState<any>([]);
  const [data, setData] = useState<any[]>([]);
  const [linkImage, setLinkImage] = useState<any>(null);

  const [itemsByCommentId, setItemsByCommentId] = useState<Record<number, { content: string, items: CommentRecord[] }>>({});
  const [loadingReplies, setLoadingReplies] = useState<number[]>([]);
  const [toggleByCommentId, setToggleCommentId] = useState<Record<number, boolean>>({})
  const [itemOpenModalPost, setItemOpenModalPost] = useState<any>(null);
  const [dataContentType, setDataContentType] = useState<any>([]);
  const [dataRatingDefinition, setDataRatingDefinition] = useState<any>([]);

  const loadTableData = async () => {
    try {
      dispatch(getCommentList(query));

      const response: any = await commentApi?.getSummaryComments(query);
      if (response.code == 200) setSummaryData(response?.data);
    } catch {
      console.log("log data")
    }
  }

  useEffect(() => {
    if (lstComment?.items) {
      setData(lstComment?.items)
    }
  }, [lstComment])


  const searchData = () => {
    setQuery({
      ...query,
      comment: commentSearch || "",
      type: typeCommentSearch || "",
      source: commentSourceSearch || "",
      approvalStatus: approvedStatusSearch || "",
      status: statusSearch || "",
      postId: (postIDSearch?.value !== "all" && postIDSearch?.value) ? postIDSearch?.value : "",
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        comment: "",
        type: "",
        source: "",
        approvalStatus: "",
        status: "",
        postId: "",
        startDate: "",
        endDate: "",
        sortBy: SORT_BY_DEFAULT,
        orderBy: ORDER_BY_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );

    setCommentSearch((_prev) => "");
    setTypeCommentSearch("");
    setCommentSourceSearch("");
    setApprovedStatusSearch("");
    setPostIDSearch("");
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const handleOnConfirmUpdate = async (item: {
    id: number;
    status: string;
  }) => {
    try {
      if (!item) {
        return;
      }
      const response: any = await commentApi.putComment(item?.id, {
        status: item?.status,
      });
      if (response?.code === 200) {
        const newComment = response.data;
        if (!newComment.parentCommentId) {
          setData((oldDatas) => oldDatas.map(oldData => oldData.id === newComment.id ? ({
            ...oldData,
            status: item.status,
          }) : oldData))
        } else if (itemsByCommentId[newComment.parentCommentId]) {
          setItemsByCommentId(oldItemsByCommentId => ({
            ...oldItemsByCommentId,
            [newComment.parentCommentId]: {
              ...itemsByCommentId[newComment.parentCommentId],
              items: itemsByCommentId[newComment.parentCommentId].items.map(oldData => oldData.id === newComment.id ? ({
                ...oldData,
                status: item.status,
              }) : oldData)
            }
          }))
        }
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Change status

  const fetchReplies = async (comment: CommentRecord) => {
    const { id: commentId, comment: commentContent } = comment
    let page = 1;
    const res = await commentApi.getReplyComments({
      parentCommentId: commentId,
      page: page,
      limit: 99999999
    });
    setItemsByCommentId((oldItemByCommentId) => ({
      ...oldItemByCommentId,
      [commentId]: {
        content: commentContent,
        items: res?.data?.items || []
      }
    }))
  };

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };


  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Comment Management")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);


  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, [setQuery]);

  const handleExpand = async (comment: CommentRecord) => {
    const { id: commentId } = comment;
    if (!comment.replies) {
      return;
    }
    // if (loadingReplies.includes(commentId)) {
    //   return;
    // }
    setLoadingReplies((prevLoadingReplies) => [...prevLoadingReplies, commentId])
    try {
      await fetchReplies(comment);
    } catch (error) {
      setLoadingReplies((prevLoadingReplies) => prevLoadingReplies.filter(commentIdOfReply => commentId !== commentIdOfReply))
    }
  }

  const handleUpdateApprovalOnGrid = async (id: any, value: any) => {
    if (!id) return;

    try {
      const data = {
        approvalStatus: value,
      };
      const response: any = await commentApi.updateApprovalStatusComment(id, data);
      if (response?.data) {

        const newComment = response?.data;
        if (!newComment.parentCommentId) {
          setData((oldDatas) => oldDatas.map(oldData => oldData.id === newComment.id ? ({
            ...oldData,
            approvalStatus: value,
          }) : oldData))
        } else if (itemsByCommentId[newComment.parentCommentId]) {
          setItemsByCommentId(oldItemsByCommentId => ({
            ...oldItemsByCommentId,
            [newComment.parentCommentId]: {
              ...itemsByCommentId[newComment.parentCommentId],
              items: itemsByCommentId[newComment.parentCommentId].items.map(oldData => oldData.id === newComment.id ? ({
                ...oldData,
                approvalStatus: value,
              }) : oldData)
            }
          }))
        }
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  const formattedData = useMemo(() => {
    const comments: Array<CommentRecord & { position?: number, level: number }> = [];
    const loadChildItems = (comment: CommentRecord, level: number) => {
      comments.push({
        ...comment,
        level
      });
      if (comment.replies && itemsByCommentId[comment.id]?.items?.length > 0 && !!toggleByCommentId[comment.id]) {
        for (const chilComment of itemsByCommentId[comment.id].items) {
          loadChildItems(chilComment, level + 1)
        }
      }
    }
    for (let i = 0; i < data.length; i++) {
      const comment = data[i];
      const position = summaryData?.all - ((query?.page - 1) * query?.limit + i)
      const level = 0;
      comments.push({
        ...comment,
        position,
        level: 0,
      });
      if (comment.replies && itemsByCommentId[comment.id]?.items?.length > 0 && !!toggleByCommentId[comment.id]) {
        for (const chilComment of itemsByCommentId[comment.id].items) {
          loadChildItems(chilComment, level + 1)
        }
      }
    }
    return comments
  }, [data, query, itemsByCommentId, summaryData, toggleByCommentId, lstComment])

  const columns = useMemo(() => {

    return [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ row }: any) => {
          return (
            <div style={{ width: 35 }}>
              {row.original?.position}
            </div>
          )
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 100,
        thClass: "text-center",
        filterable: false,
        sortable: false,
        Cell: ({ value, row }: any) => {
          const item = row.original;
          if (value === "DELETED") {
            return (
              <span className={`rounded-pill badge bg-${COLOR_CONTENT_COMMENT_STATUS[value] || "secondary"}`}>
                {t(LIST_CONTENT_COMMENT_STATUS_OPTION?.find((i) => i?.value === value)?.label || "")}
              </span>
            );
          }
          return (
            <div className="form-check form-switch form-switch-sm text-center" dir="ltr" style={{ minWidth: "80px" }}>
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={value === "ACTIVE"}
                onChange={(e) => {
                  const checked = e.target.checked;
                  handleOnConfirmUpdate({
                    id: item.id,
                    status: checked ? "ACTIVE" : "INACTIVE",
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Approved Status"),
        accessor: "approvalStatus",
        thWidth: 150,
        thClass: "text-center",
        Cell: ({ value, row }: any) => {
          const record = row.original;
          const sourceComment = record.source;
          return (
            <div className="text-center" style={{ minWidth: 100 }}>
              <div className="position-relative d-flex align-items-center gap-1 justify-content-center">
                {sourceComment === "ai" ? (
                  <UpdateDropdownStatus
                    item={record}
                    valueDefault={value}
                    handleUpdateStatus={handleUpdateApprovalOnGrid}
                    optionsStatus={LIST_CONTENT_AI_APPROVAL_STATUS_OPTION}
                    colorStatus={COLOR_CONTENT_AI_APPROVAL_STATUS}
                  />
                ) : (
                  <span className={`rounded-pill badge bg-${COLOR_CONTENT_AI_APPROVAL_STATUS[value] || "secondary"}`}>
                    {t(LIST_CONTENT_AI_APPROVAL_STATUS_OPTION?.find((item) => item?.value === value)?.label || "")}
                  </span>
                )}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Comment Level"),
        accessor: "CommentLevel",
        thWidth: 140,
        thClass: "text-center",
        Cell: ({ value, row }: any) => {
          const level = row.original?.level;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span className={`rounded-pill badge bg-${level == 0 ? "primary" : "warning"}`}>
                {level == 0 ? t("Level Comment") : t("Level Reply Comment")}
              </span>
            </div>
          )
        },
      },
      {
        Header: t("Comment Content"),
        accessor: "comment",
        thWidth: 400,
        Cell: ({ row }: any) => {
          const record = row.original;
          const comment = record.comment;
          const isExpanded = !!toggleByCommentId[record.id]
          const level = record.level || 0;
          const marginLeft = level * 20;

          return (
            comment && (
              <div className="d-flex flex-column" style={{ paddingLeft: marginLeft, maxWidth: 400 }}>
                <div className="d-flex flex-row align-items-center">
                  {record.replies === true && (
                    <span
                      onClick={() => {
                        if (!toggleByCommentId[record.id]) {
                          handleExpand(record)
                        }
                        setToggleCommentId((oldToggleByCommentId) => ({
                          ...oldToggleByCommentId,
                          [record.id]: !oldToggleByCommentId[record.id]
                        }))

                      }}
                      style={{ cursor: "pointer", marginRight: 6, fontSize: 15, userSelect: "none" }}
                    >
                      {isExpanded ? "▼" : "▶"}
                    </span>
                  )}
                  <CopyWrapper
                    contentCopy={comment}
                    style={{ minWidth: "230px", whiteSpace: "pre-line" }}
                  >
                    <CollapseContent
                      style={{ maxWidth: "230px" }}
                      dataOriginal={comment}
                      isRank={false}
                      isInlineBlock={true}
                      isShowModal={true}
                      titleModal={t("Content")}
                    />
                  </CopyWrapper>
                </div>
                {record?.parentCommentId && (
                  <small className="text-secondary">
                    <i className="ri-reply-fill"></i> {`${t("Replying to")} : "${itemsByCommentId[record.parentCommentId]?.content}"`}
                  </small>
                )}
              </div>
            )
          );
        },
      },
      {
        Header: t("User Comment"),
        accessor: "user",
        thWidth: 280,
        Cell: ({ value: user }: any) => {
          const userType = user?.type;
          let avatar = user?.profile?.imageUrls?.[0] || "";
          let nickname = user?.profile?.nickname || user?.profile?.fullname || "";
          let email = user?.profile?.email || "";
          const images = user?.profile?.imageUrls;
          const formatAvatars = images?.map((item: string) => ({ url: item }));

          if (userType === "MANAGER") {
            avatar = user?.store?.thumbnailUrl || "";
            nickname = user?.store?.managerName || "";
            email = user?.store?.managerEmail || "";
          }

          return (
            <div className="d-flex align-items-center gap-2">
              <div
                className="cursor-pointer overflow-hidden object-fit-cover"
                style={{ height: "45px", width: "45px", minWidth: "45px" }}
                onClick={() =>
                  setLinkImage(
                    formatAvatars && formatAvatars?.length > 1 && userType === "APPLICANT"
                      ? { urls: formatAvatars }
                      : { url: avatar }
                  )
                }
              >
                <img
                  className="overflow-hidden object-fit-cover rounded-circle"
                  src={avatar || NO_IMAGE_USER}
                  alt={nickname}
                  height={45}
                  width={45}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = NO_IMAGE_USER;
                  }}
                />
              </div>
              <div className="d-flex flex-column">
                {(userType === "MANAGER" && !user?.store) || (userType === "APPLICANT" && !user?.profile) ? (
                  <>
                    {user?.email ? (
                      <div>
                        <small>{t("Email SNS")}:</small> {user?.email}
                      </div>
                    ) : (
                      <div className="cursor-pointer">{user?.providerId}</div>
                    )}
                  </>
                ) : (
                  <>
                    <span>{nickname || "-"}</span>
                    <small className="text-secondary">{email || ""}</small>
                  </>
                )}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Original Post"),
        accessor: "referralCode",
        thWidth: 300,
        Cell: ({ row }: any) => {
          const record = row.original;
          const postTitle = record?.post?.title;
          const contentType = record?.post?.type;
          const date = formatDateStringToKorea(record?.post?.postedAt || "");
          return (
            <div 
              className="d-flex gap-0 flex-column cursor-pointer" 
              style={{ maxWidth: "300px", minWidth: "250px" }}
              onClick={() => {
                if (record?.post?.id) {
                  setItemOpenModalPost(record?.post?.id)
                }
              }}
              >
              <div className="cursor-pointer text-primary" style={{ whiteSpace: "normal" }}>{postTitle}</div>
              <div className="d-flex flex-column">
                <small className="text-secondary">{date || ""}</small>
                <div>
                  <span className={`rounded-pill badge bg-${COLOR_CONTENT_TYPE[contentType] || "secondary"}`}>
                    {t(
                      LIST_CONTENT_TYPE_OPTION?.find(
                        (item) => String(item?.value) === String(contentType)
                      )?.label || ""
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Type Comment"),
        accessor: "type",
        thWidth: 150,
        thClass: "text-center",
        Cell: ({ value }: any) => (
          <div className="text-center" style={{ minWidth: 80 }}>
            <span className={`rounded-pill badge bg-${COLOR_LIST_TYPE_COMMENT[value] || "secondary"}`}>
              {t(LIST_TYPE_COMMENT_OPTION?.find((item) => item?.value === value)?.label || "")}
            </span>
          </div>
        ),
      },
      {
        Header: t("Source Comment"),
        accessor: "source",
        thWidth: 150,
        thClass: "text-center",
        Cell: ({ value }: any) => (
          <div className="text-center" style={{ minWidth: 80 }}>
            <span className={`rounded-pill badge bg-${COLOR_LIST_COMMENT_SOURCE[value] || "secondary"}`}>
              {t(LIST_COMMENT_SOURCE_OPTION?.find((item) => item?.value === value)?.label || "")}
            </span>
          </div>
        ),
      },
      {
        Header: t("Comment Date"),
        accessor: "createdAt",
        thWidth: 150,
        thClass: "text-end",
        sortable: true,
        Cell: ({ value }: any) => {
          const date = formatDateStringToKorea(value);
          const arrDate = String(date || "").split(" ");
          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {value ? (
                <>
                  <span>{arrDate?.[0]}</span>
                  <br />
                  <span className="text-secondary">{arrDate?.[1]}</span>
                </>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language, data, formattedData, itemsByCommentId, toggleByCommentId])


  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [ratingDefinitions, contentTypes]: any = await Promise.all([
          contentApi.ratingDefinitions(),
          contentApi.contentTypes({limit: 1000})
        ]);

        if (ratingDefinitions?.data) {
          setDataRatingDefinition(ratingDefinitions?.data);
        }

        if (contentTypes?.data) {
          const formatContentType = contentTypes?.data?.items?.filter((type: any) => type?.id !== 0)?.sort((a: any, b: any) => a.ordering - b.ordering);
          setDataContentType(formatContentType?.map((type: any) => ({
            value: type?.id,
            label: type?.name
          })));
        }
      } catch (error: any) {
        return error;
      }
    };
    handleCallAllOption();
  }, []);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Comments")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Comment")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summaryData?.all || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total System Comment")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summaryData?.comment || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total AI Comment")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summaryData?.ai || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Comment")}
                          isShow={!!commentSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Comment")}...`}
                            value={commentSearch}
                            onChange={(e) => setCommentSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Type Comment")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={LIST_TYPE_COMMENT_OPTION || []}
                            placeholder={`${t("Type Comment")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={typeCommentSearch}
                            onChangeSelect={(e: any) => {
                              setTypeCommentSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_LIST_TYPE_COMMENT}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Source Comment")} isShow={true}>
                          <DropdownStatusNew
                            name="source"
                            dataList={LIST_COMMENT_SOURCE_OPTION || []}
                            placeholder={`${t("Source Comment")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={commentSourceSearch}
                            onChangeSelect={(e: any) => {
                              setCommentSourceSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_LIST_COMMENT_SOURCE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Approved Status")} isShow={true}>
                          <DropdownStatusNew
                            name="approved_status"
                            dataList={LIST_CONTENT_AI_APPROVAL_STATUS_OPTION || []}
                            placeholder={`${t("Approved Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={approvedStatusSearch}
                            onChangeSelect={(e: any) => {
                              setApprovedStatusSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_CONTENT_AI_APPROVAL_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_CONTENT_COMMENT_STATUS_OPTION || []}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_CONTENT_COMMENT_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Post")} isShow={true}>
                          <DropdownAsyncPost
                            name="postId"
                            placeholder={`${t("Post")}...`}
                            listCheckedOption={postIDSearch}
                            onChangeSelect={(event: any) =>
                              setPostIDSearch(event)
                            }
                            isAllOption={true}
                            hideSelectedOptions={true}
                            isMulti={false}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-3 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>

                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-comment"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={formattedData || []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={summaryData?.all}
                      customPageCount={Math.ceil(
                        Number(summaryData?.all) /
                        Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isCommentLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>


        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemOpenModalPost && (
          <ContentForm
            id={itemOpenModalPost}
            dataRatingDefinition={dataRatingDefinition}
            dataContentType={dataContentType}
            setLinkImage={setLinkImage}
            onCloseClick={() => setItemOpenModalPost(null)}
            triggerRefresh={() => {
              setItemOpenModalPost(null);
              loadTableData();
            }}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CommentList;

